/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCollectionlist = {
  init: function($section) {
      this.$section = $section
    // Add settings from schema to current object
    // Shopify.theme.jsCollectionlist = $.extend(this, Shopify.theme.getSectionData($section));

    
      this.createSlider();
   
   console.log($section);
  },
  createSlider: function() {

    let CollectionListSlider = this.$section.find('.collectionlistSlider');
  $(CollectionListSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      pageDots: true,
      contain: true,
      prevNextButtons: true,
      initialIndex: 0,
      groupCells: true,
      arrowShape: { 
  x0: 10,
  x1: 60, y1: 50,
  x2: 60, y2: 40,
  x3: 20
},
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(CollectionListSlider).on( 'settle.flickity', function() {
            $(CollectionListSlider).flickity('resize')
          });
        }
      }
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;